import React, { useState, useEffect } from "react";
import { Form, Field, FormSpy} from "react-final-form";
import {
  Modal,
  ModalBody, Row, Col, ButtonToolbar, Button, Card, CardBody, Container, ModalHeader
} from "reactstrap";
import { connect } from 'react-redux';
import { useParams, useHistory, withRouter } from "react-router-dom";
import { useDispatch, flashSuccess, flashError, sendFlashMessage } from "@/shared/components/flash"
import formValidation from "@/shared/validation/addEvent";
import renderToggleButtonField from "@/shared/components/form/ToggleButton";
import axios from "axios";
import renderSelectField from '@/shared/components/form/Select'
import CheckboxField from '@/shared/components/form/CheckboxField';
// import CheckboxField from '@/shared/components/form/CheckBox';
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor';
import AddIconTabs from "./AddIconTabs";
import { fetchEventTypes, getEventLedgerCodes, getMilestoneOptions } from '@/shared/apiHelper'
import { labelizeNamedData, labelizeData, getValueFromMixed, isBadgeAward, isCustomAward, isSaveToHierarchyEnabled } from '@/shared/helpers'
import { getAuthUser } from '@/containers/App/auth';
import { makeFormData } from './common'
import LedgerCodes from './LedgerCodes';
import {Space, Table} from 'antd';
import AddAwardLevel from "./AddAwardLevel";
import {FieldArray} from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import TrashOutlineIcon from "mdi-react/TrashOutlineIcon";
import AddSocialWallImageModal from "./AddSocialWallImageModal";
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import RemoveHierarchyModal from "./RemoveHierarchyModal";
import RemoveSelectedHierarchyModal from "./RemoveSelectedHierarchyModal";
import DeletedResultHierarchyModal from "./DeletedResultHierarchyModal";
import SaveHierarchyModal from "./SaveHierarchyModal";
import SaveSelectedHierarchyModal from "./SaveSelectedHierarchyModal";
import SavedResultHierarchyModal from "./SavedResultHierarchyModal";

const fetchEvent = async (oId, pId, eId) => {
  try {
    const response = await axios.get(`/organization/${oId}/program/${pId}/event/${eId}`);
    return response.data;
  } catch (e) {
    throw new Error(`API error:${e?.message}`);
  }
};

const Edit = ({organization, theme, rtl}) => {

  const { programId, eventId } = useParams();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isOpenHierarchy, setOpenHierarchy] = useState(false);
  const [isDeleteHierarchy, setDeleteHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [isDeleteHierarchyList, setDeleteHierarchyList] = useState(false);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [isDeleteHierarchyResult, setDeleteHierarchyResult] = useState(false);
  const [formValues, setFormValues] = useState([]);
  const [hierarchyListData, setHierarchyListData] = useState([]);

  const [deleteHierarchyListData, setDeleteHierarchyListData] = useState([]);

  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [deletehierarchyListDataResult, setdeleteHierarchyListDataResult] = useState([]);
  const [eventTypeId, setEventTypeId] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState(null);
  let [event, setEvent] = useState(null);
  const [eventTypesRaw, setEventTypesRaw] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [activeTab, setActiveTab] = useState('2');
  const [milestoneOptions, setMilestoneOptions] = useState([]);
  const [ledgerCodes, setLedgerCodes] = useState([]);
  const [dataEventAwardsLevels, setDataEventAwardsLevels] = useState([]);
  const [visible, setVisible] = useState(false);
    const [dataAwardLevel, setDataAwardLevel] = useState({
        id: 0,
        event_id: 0,
        amount: 0,
        award_level_id: 0,
    });
  const dispatch = useDispatch()
  const set_path = (icon) => {
    if (!icon?.path) return '';
    if (icon.path.startsWith('http://') || icon.path.startsWith('https://')) {
      return icon.path;
    }
    return `${process.env.REACT_APP_API_STORAGE_URL}/${icon.path}`;
  }
  const [checkedState, setCheckedState] = useState([]);
  const [isSocialWallOpen, setSocialWallModal] = useState(false);

  const fetchProgramData = async (id) => {
    try {
      const { id: organizationId } = organization
      const response = await axios.get(`/organization/${organizationId}/program/${id}`);
      setProgram(response.data)
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  };
  const cb_CodeAction = () => {
    getListLedgerCodes(program)
  }

  const getListLedgerCodes = (program) => {
    getEventLedgerCodes(program.organization_id, program.id)
    .then(ledgercodes => {
      setLedgerCodes(labelizeNamedData(ledgercodes, ["id", "ledger_code"]))
    })
  }
  useEffect(() => {
    if( program?.id ){
      getListLedgerCodes(program)
    }
  }, [program])

  useEffect(() => {
    if (organization?.id && programId) {
      fetchProgramData(programId)
    }
  }, [programId, organization]);

    useEffect(() => {
        if (eventId && program?.id) {
            setLoading(true)
            fetchEvent(program.organization_id, program.id, eventId)
                .then(res => {
                    setEvent(res)
                    setEventTypeId(res.event_type_id);
                    setDataEventAwardsLevels(res.eventAwardsLevel);
                    setLoading(false)
                })
        }
    }, [program, eventId]);

  useEffect( () => {
    if( event?.id && program?.id ) {
      fetchEventTypes(organization.id, programId)
      .then(evtypes => {
        setEventTypesRaw(evtypes)
        const authUser = getAuthUser();
        const isManager = authUser && !authUser.isSuperAdmin && !authUser.isAdmin;
        if (isManager && !program.allow_activation_awards) {
          setEventTypes(labelizeNamedData(evtypes.filter(t => t.name !== 'Activation')));
        } else {
          setEventTypes(labelizeNamedData(evtypes));
        }
      })
      if( program.allow_milestone_award ) {
        getMilestoneOptions(program.organization_id, program.id)
        .then( o => {
          setMilestoneOptions(labelizeData(o))
        })
      }
    }
  }, [event])

  let history = useHistory();

  const isMilestoneAward = (event_type_id) => {
    const v = getValueFromMixed(event_type_id)
    for(var i in eventTypesRaw)  {
      if( eventTypesRaw[i].type == 'milestone award' && eventTypesRaw[i].id === parseInt(v) ) {
        return true;
      }
    }
    // return event_type_id === 9;
  }

  const submitEvent = (values) => {
    if(isCustomAward(eventTypeId)){
      values.award_message_editable = true
    }
    const eventData = makeFormData(program, values)
    axios
      .put(`/organization/${program.organization_id}/program/${programId}/event/${eventId}`, eventData)
      .then((res) => {
        if (res.status == 200) {
          flashSuccess(dispatch, "Event saved!")
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data)
        setLoading(false);
      });
  };

  const onSubmit = (values) => {
    submitEvent(formValues);
    toggleHierarchy();
  };

  const onSubmitHierarchy = () => {
    if(isCustomAward(eventTypeId)){
      formValues.award_message_editable = true
    }
    const eventData = makeFormData(program, formValues)
    axios
      .put(`/organization/${program.organization_id}/program/${programId}/event/${eventId}/hierarchy-prepare`, eventData)
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListData(res.data);

          toggleHierarchy();
          const tmpCheckedState = [];
          res.data.map(item => {
              tmpCheckedState.push({checked: true, value: item.id});
          });
          setCheckedState(tmpCheckedState);
          toggleHierarchyList();
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data)
        setLoading(false);
        toggleHierarchy();
      });
  };

  const onDeleteHierarchy = () => {

    axios
       .get(`/organization/${program.organization_id}/program/${programId}/event/${eventId}/delete-hierarchy-list`).then((res) => {
        if (res.status == 200) {
          setDeleteHierarchyListData(res.data);
          const tmpCheckedState = [];
          res.data.map(item => {
              tmpCheckedState.push({checked: true, value: item.event_id});
          });
          setCheckedState(tmpCheckedState);
          toggleDeleteHierarchyList();
          toggleDeleteHierarchy();
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data)
        setLoading(false);
        toggleDeleteHierarchyList();
      });
  };

  const onDeleteHierarchyList = () => {
    const eventData = {};
    const eventIds = checkedState
      .filter((item) => item.checked)
      .map((item) => item.value);
    eventData.event_ids = eventIds;

    axios
      .delete(
        `/organization/${program.organization_id}/program/${programId}/event/${eventId}/delete-event-hierarchy`,
        {
          data: eventData,
        }
      )
      .then((res) => {
        if (res.status === 200) {
          const list = res.data.deleted_data;
          setdeleteHierarchyListDataResult(list);
          flashSuccess(dispatch, "Event(s) deleted successfully!");
          toggleDeleteHierarchyResult();
          toggleDeleteHierarchyList();
          // history.push(`/program/view/${programId}`)
        }
      })
      .catch((err) => {
        flashError(
          dispatch,
          err.response?.data || "Failed to fetch delete list"
        );
        setLoading(false);
        toggleDeleteHierarchyResult();
      });
  };

  const onSubmitHierarchyList = () => {
    const eventData = makeFormData(program, formValues)
    const programIds = [];
    console.log('checkedState',checkedState)
    checkedState.map(item => {
      if(item.checked){
        programIds.push(item.value)
      }
    });
    eventData.programIds = programIds;

    axios
      .put(`/organization/${program.organization_id}/program/${programId}/event/${eventId}/hierarchy`, eventData)
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListDataResult(res.data);
          toggleHierarchyList();
          toggleHierarchyResult();
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data)
        setLoading(false);
        toggleHierarchyList();
      });
  };

  const onClickCancel = () => {
    history.goBack();
  }

  const toggle = () => {
    setOpen(prevState => !prevState)
  }

  const onSubmitForm = (values) => {
    setFormValues(values)
    if (isSaveToHierarchyEnabled(program?.rootProgram, program)) {
      toggleHierarchy();
    } else {
      submitEvent(values);
    }
  }

  const toggleHierarchy = (values) => {
    setOpenHierarchy(prevState => !prevState)
  }
const toggleDeleteHierarchy = (values) => {
    setDeleteHierarchy(prevState => !prevState)
  }
  const toggleHierarchyList = () => {
    setOpenHierarchyList(prevState => !prevState)
  }

const toggleDeleteHierarchyList = () => {
  setDeleteHierarchyList((prevState) => !prevState);
};

  const toggleHierarchyResult = () => {
    setOpenHierarchyResult(prevState => !prevState)
  }
 const toggleDeleteHierarchyResult = () => {
    setDeleteHierarchyResult(prevState => !prevState)
  }

  const setEventIcon = ([fieldName, fieldVal], state, { changeValue }) => {
    setOpen(false);
    changeValue(state, 'event_icon_id', () => fieldVal.id);
    changeValue(state, fieldName, () => fieldVal);
  }

  const toggleSocialWall = () => {
    setSocialWallModal(prevState => !prevState)
  }

  const setSocialWall = ([fieldName, fieldVal], state, { changeValue }) => {
    changeValue(state, 'social_wall_image_id', () => fieldVal.id);
    changeValue(state, fieldName, () => fieldVal);
    setSocialWallModal(false);
  }

  const removeSocialWalImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (window.confirm("Are you sure to delete Social Wall Background Image?")) {
      axios.delete(`/organization/${program.organization_id}/program/${program.id}/event/${event.id}/social-wall-image`, {})
        .then((res) => {
          flashSuccess(dispatch, 'Image deleted successfully!');
          setEvent({ ...event, social_wall_image_id: null, social_wall_image: null });
        }).catch((err) => {
          flashError(dispatch, err.response.data)
        });
    }
  }

  const onChangeAwardValue = ([field], state, { setIn, changeValue }) => {
    const v = field.target.value
    if (isNaN(v)) return;
    if (field.target.name === 'max_awardable_amount') {
      const field = state.fields["awarding_points"];
      field.change(program.factor_valuation * v);
    }
    else if (field.target.name === 'awarding_points') {
      const field = state.fields["max_awardable_amount"];
      field.change(v / program.factor_valuation);
    }
  }

  const onChangeEventType = (value) => {
    setEventTypeId(value?.value);
    setSelectedEventType(value || null);
  }

  if (loading || !event) {
    return <p>Loading...</p>;
  }

  if (event.event_icon) {
    event.icon = event.event_icon
  }

  event.awarding_points = parseFloat(event.max_awardable_amount) * parseInt(program.factor_valuation)

    const columnsEventAwardsLevel = [
        {
            title: 'Award Level ID',
            dataIndex: 'id',
            key: 'id',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Award Level Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <>
                    <a style={{color:'#70bbfd',cursor:"pointer"}} onClick={()=> handleAwardLevelEdit(record)}>Edit</a> |
                    <a style={{color:'#70bbfd',cursor:"pointer"}} onClick={()=>handleAwardLevelDelete(record)}> Delete</a>
                </>
            ),
        },
    ];

  const columnsHierarchyList = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Copy\\Update?',
      key: 'action',
      render: (_, record, index) => (
        <>
          <div className="checkbox-custom2">
            <CheckboxField
              name={`action-checkbox-${record.id}`}
              label={record.event_will_be_updated ? 'update' : 'add'}
              checked={checkedState[index].checked}
              disabled={checkedState[index].value === program.id ? true : false}
              onChange={(e) => {
                const tmpCheckedState = [...checkedState];
                tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
                setCheckedState(tmpCheckedState)
              }}
            />
          </div>
        </>
      ),
    },
  ];

 const columnsDeleteHierarchyList = [
   {
     title: "Delete?",
     key: "action",
     render: (_, record, index) => (
       <>
         <div className="checkbox-custom2">
           <CheckboxField
             name={`action-checkbox-${record.event_id}`}
             checked={checkedState[index].checked}
             disabled={checkedState[index].value === Number(eventId) ? true : false}
             onChange={(e) => {
               const tmpCheckedState = [...checkedState];
               tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
               setCheckedState(tmpCheckedState);
             }}
           />
         </div>
       </>
     ),
   },
   {
     title: "Event ID",
     dataIndex: "event_id",
     key: "event_id",
     render: (text) => <a>{text}</a>,
   },
   {
     title: "Event Name",
     dataIndex: "event_name",
     key: "event_name",
   },
   {
     title: "Program Name",
     dataIndex: "program_name",
     key: "event_name",
   },
   {
     title: "Event Type",
     dataIndex: "event_type",
     key: "event_type",
   },
 ];

  const columnsHierarchyResult = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Result',
      dataIndex: 'result',
      key: 'result',
    },
  ];

  const toggleModal = () => {
    setDataAwardLevel({
      id: 0,
      event_id: eventId,
      amount: 0,
      award_level_id: 0,
    });
    setVisible(!visible);
  };

  const handleSave = (data) => {
    axios.put(`/organization/${program.organization_id}/program/${programId}/event-award-level/${eventId}`, data)
      .then((res) => {
        if (res.status == 200) {
          flashSuccess(dispatch, "Event saved!")
                    fetchEvent(program.organization_id, program.id, eventId)
                        .then(res => {
                            setDataEventAwardsLevels(res.eventAwardsLevel);
                        })
                }
            }).catch((err) => {
            flashError(dispatch, err.response.data)
            setLoading(false);
        });
    };

    const handleAwardLevelEdit = (data) => {
        setDataAwardLevel(data);
        setVisible(!visible);
    };

    const handleAwardLevelDelete = (data) => {
        axios.delete(`/organization/${program.organization_id}/program/${programId}/event-award-level/${eventId}`, { data: data })
            .then((res) => {
                if (res.status == 200) {
                    flashSuccess(dispatch, "Event saved!")
                    fetchEvent(program.organization_id, program.id, eventId)
                        .then(res => {
                            setDataEventAwardsLevels(res.eventAwardsLevel);
                        })
                }
            }).catch((err) => {
            flashError(dispatch, err.response.data)
            setLoading(false);
        });
    };

    const onClickDeleteEvent = async (e, event_id) => {
        if (!event_id) return;

        setLoading(true);

        try {
            const res = await axios.delete(
            `/organization/${program.organization_id}/program/${program.id}/event/${event_id}`
            );

            if (res.status === 200) {
                // Redirect to main event page
                window.location.href = `/program/view/${program.id}?message=Event deleted successfully!`;
            }
        } catch (err) {
            console.error('Delete failed:', err.response?.data || err.message);
            dispatch(
            sendFlashMessage(<ApiErrorMessage errors={err.response?.data} />, 'alert-danger')
            );
        } finally {
            setLoading(false);
        }
    };

  if (event) {
    return (
      <Container className="dashboard">
        <Col md={12}>
          <Card>
            <CardBody style={{ display: "flex" }}>
              <Form
                mutators={{
                  // // expect (field, value) args from the mutator
                  // setValue: ([field, value], state, { changeValue }) => {
                  //   changeValue(state, field, () => value)
                  // }
                  onChangeAwardValue,
                  setEventIcon,
                  setSocialWall,
                }}
                onSubmit={onSubmitForm}
                validate={(values) => formValidation.validateForm(values)}
                initialValues={event}
              >
                {({ handleSubmit, form, submitting, pristine, values }) => (
                  <>
                    <form className="form" onSubmit={handleSubmit}>
                      <Row className="w100">
                        <Col md="6" lg="6" xl="6">
                          <h3 className="mb-4">Edit Event</h3>
                        </Col>
                        <Col md="6" lg="6" xl="6" className="text-right">
                          <ButtonToolbar className="modal__footer flex justify-content-right w100">
                            <Button
                              outline
                              color="primary"
                              className="mr-3"
                              onClick={onClickCancel}
                            >
                              Close
                            </Button>{" "}
                            <Button
                              type="submit"
                              disabled={loading}
                              className="btn btn-primary"
                              color="#ffffff"
                            >
                              Save
                            </Button>
                            <Button
                              outline
                              color="danger"
                              className="mr-3"
                              disabled={loading}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleDeleteHierarchy();
                              }}
                            >
                              Delete Event
                            </Button>
                            {/* <Button
                                        outline
                                        color="danger"
                                        className="mr-3"
                                        disabled={loading}
                                        onClick={() => {
                                            if (window.confirm("Are you sure to delete this Event?")) {
                                                onClickDeleteEvent(null, event?.id); // Assuming `event.id` is the current event ID
                                            }
                                        }}
                                        >
                                            Delete Event
                                        </Button> */}
                          </ButtonToolbar>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6" lg="4" xl="4">
                          <div className="form__form-group">
                            <span className="form__form-group-label">
                              Select Event Type
                            </span>
                            <div className="form__form-group-field">
                              <div className="event-type-hover">
                              <div className="form__form-group-row">
                                <Field
                                  name="event_type_id"
                                  options={eventTypes}
                                  component={renderSelectField}
                                />
                                <FormSpy subscription={{ values: true }}>
                                  {({ values }) => {
                                    if (!values?.event_type_id || !eventTypes.length) return null;

                                    // normalize value (id OR option object)
                                    const selectedValue =
                                      typeof values.event_type_id === 'object'
                                        ? values.event_type_id.value
                                        : values.event_type_id;

                                    const selected = eventTypes.find(
                                      et => String(et.value) === String(selectedValue)
                                    );

                                    if (!selected?.description) return null;

                                    return (
                                      <small
                                        style={{
                                          marginTop: 4,
                                          display: 'block',
                                          border: '1px solid #4ce1b6',
                                          padding: '4px 6px',
                                          borderRadius: '3px'
                                        }}
                                      >
                                        {selected.description}
                                      </small>
                                    );
                                  }}
                                </FormSpy>
                              </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="3" lg="4" xl="4">
                          <div className="form__form-group">
                            <span className="form__form-group-label">
                              Enable This Event
                            </span>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <Field
                                  name="enable"
                                  component={renderToggleButtonField}
                                  className={"toggle-btn-auto-width"}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="3" lg="4" xl="4">
                            <div className="form__form-group">
                            <div className="form__form-group-field">
                                <span
                                className="form__form-group-label"
                                style={{ width: "200%" }}
                                >
                                Enable Scheduled Awards
                                </span>
                                <Field
                                name="enable_schedule_award"
                                component={renderToggleButtonField}
                                defaultValue={false}
                                />
                            </div>
                            </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4" lg="4" xl="4">
                          <Field name="name">
                            {({ input, meta }) => (
                              <div className="form__form-group">
                                <span className="form__form-group-label">
                                  Event Name
                                </span>
                                <div className="form__form-group-field">
                                  <div className="form__form-group-row">
                                    <input
                                      type="text"
                                      {...input}
                                      placeholder="Event Name"
                                    />
                                    {meta.touched && meta.error && (
                                      <span className="form__form-group-error">
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col md="4" lg="4" xl="4">
                          <div className="form__form-group">
                            <span className="form__form-group-label">
                              Ledger Code
                            </span>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <Field
                                  name="ledger_code"
                                  options={ledgerCodes}
                                  isClearable={true}
                                  component={renderSelectField}
                                />
                                <LedgerCodes
                                  program={program}
                                  cb_CodeAction={cb_CodeAction}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="4" lg="4" xl="4">
                            <div className="form__form-group">
                            <div className="form__form-group-field">
                                <span
                                className="form__form-group-label"
                                style={{ width: "200%" }}
                                >
                                Disable/Bypass Award Cascading Approvals
                                </span>
                                <Field
                                name="bypass_cascading_approvals"
                                component={renderToggleButtonField}
                                defaultValue={false}
                                />
                            </div>
                            </div>
                        </Col>
                      </Row>
                      {!isBadgeAward(eventTypeId) &&
                        !isCustomAward(eventTypeId) && (
                          <Row>
                            <Col md="6" lg="4" xl="4">
                              <Field name="max_awardable_amount">
                                {({ input, meta }) => (
                                  <div className="form__form-group">
                                    <span className="form__form-group-label">
                                      Max Awardable Amount
                                    </span>
                                    <div className="form__form-group-field">
                                      <div className="form__form-group-row">
                                        <input
                                          onKeyUp={
                                            form.mutators.onChangeAwardValue
                                          }
                                          type="text"
                                          {...input}
                                          placeholder="Amount"
                                        />
                                        {meta.touched && meta.error && (
                                          <span className="form__form-group-error">
                                            {meta.error}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Field>
                            </Col>
                            <Col md="6" lg="4" xl="4">
                              <Field name="awarding_points">
                                {({ input, meta }) => (
                                  <div className="form__form-group">
                                    <span className="form__form-group-label">
                                      Awarding Points
                                    </span>
                                    <div className="form__form-group-field">
                                      <div className="form__form-group-row">
                                        <input
                                          type="text"
                                          {...input}
                                          placeholder="Awarding Points"
                                          onKeyUp={
                                            form.mutators.onChangeAwardValue
                                          }
                                        />
                                        {meta.touched && meta.error && (
                                          <span className="form__form-group-error">
                                            {meta.error}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        )}
                      {isMilestoneAward(values.event_type_id) && (
                        <Row>
                          <Col md="6" lg="4" xl="4">
                            <div className="form__form-group">
                              <span className="form__form-group-label">
                                Select Milestone Year
                              </span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-row">
                                  <Field
                                    name="milestone_award_frequency"
                                    options={milestoneOptions}
                                    component={renderSelectField}
                                    placeholder={
                                      values.milestone_award_frequency
                                        ? values.milestone_award_frequency
                                        : "Select Year"
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col md="12" lg="8" xl="8">
                          <div className="form__form-group">
                            <span className="form__form-group-label">
                              Icon
                            </span>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <div
                                  className="border_hover_div"
                                  onClick={() => setOpen(true)}
                                >
                                  <div className="text">
                                    {values.icon
                                      ? values.icon.name
                                      : "+ Add an Icon"}
                                  </div>
                                  {values.icon && (
                                    <div className="email_icon">
                                      <img
                                        src={set_path(values.icon)}
                                        alt="icons"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <Field name="event_icon_id">
                              {({ input, meta }) => (
                                <>
                                  <input
                                    type="hidden"
                                    {...input}
                                    placeholder="Event Icon"
                                  />
                                  {meta.touched && meta.error && (
                                    <span className="form__form-group-error">
                                      {meta.error}
                                    </span>
                                  )}
                                </>
                              )}
                            </Field>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12" lg="8" xl="8">
                          <div className="form__form-group">
                            <span className="form__form-group-label">
                              Social Wall Background
                            </span>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <div
                                  className="border_hover_div"
                                  onClick={() => toggleSocialWall()}
                                >
                                  <div
                                    className="text"
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {values.social_wall_image ? (
                                      <>
                                        <div
                                          style={{
                                            width: "85%",
                                            textAlign: "center",
                                          }}
                                        >
                                          {values.social_wall_image.name}
                                        </div>
                                        <div className="action-btn">
                                          <Button
                                            size="sm"
                                            type="button"
                                            onClick={(event) =>
                                              removeSocialWalImage(event)
                                            }
                                          >
                                            <TrashOutlineIcon />
                                          </Button>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="w-100 text-center">
                                        + Add an image
                                      </div>
                                    )}
                                  </div>

                                  {values.social_wall_image && (
                                    <div className="email_icon">
                                      <img
                                        src={set_path(values.social_wall_image)}
                                        alt="icons"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <Field name="social_wall_image_id">
                              {({ input, meta }) => (
                                <>
                                  <input
                                    type="hidden"
                                    {...input}
                                    placeholder="Event Icon"
                                  />
                                  {meta.touched && meta.error && (
                                    <span className="form__form-group-error">
                                      {meta.error}
                                    </span>
                                  )}
                                </>
                              )}
                            </Field>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6" lg="4" xl="4">
                          <div className="form__form-group">
                            <div className="form__form-group-field">
                              <span
                                className="form__form-group-label"
                                style={{ width: "200%" }}
                              >
                                Post to Social Wall
                              </span>
                              <Field
                                name="post_to_social_wall"
                                component={renderToggleButtonField}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {!isCustomAward(eventTypeId) && (
                        <Row>
                          <Col md="6" lg="4" xl="4">
                            <div className="form__form-group">
                              <div className="form__form-group-field">
                                <span
                                  className="form__form-group-label"
                                  style={{ width: "200%" }}
                                >
                                  Award Message Editable
                                </span>
                                <Field
                                  name="award_message_editable"
                                  component={renderToggleButtonField}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <Field name="message">
                            {({ input, meta }) => (
                              <div className="form__form-group">
                                <span className="form__form-group-label">
                                  Award Message
                                </span>
                                <div className="form__form-group-field">
                                  <div className="form__form-group-row">
                                    {/* <input
                                      type="text"
                                      {...input}
                                      placeholder="Award Message"
                                    /> */}
                                    <WYSIWYGEditor
                                      value={input.value}
                                      onChange={input.onChange}
                                      onBlur={input.onBlur}
                                    />
                                    {meta.touched && meta.error && (
                                      <span className="form__form-group-error">
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Field>
                        </Col>
                      </Row>
                    </form>
                    <Modal
                      className={`modal-program-events-icons modal-lg ltr-support`}
                      isOpen={isOpen}
                      toggle={toggle}
                    >
                      <ModalBody className="modal-lg">
                        <Col md={12} lg={12}>
                          <Row className="w100">
                            <Col md="6" lg="6" xl="6">
                              <h3>Insert Icon</h3>
                            </Col>
                          </Row>
                          <div className="pt-5 tabs">
                            <AddIconTabs
                              onSelectIconOK={form.mutators.setEventIcon}
                              activeTab={activeTab}
                              onCancel={() => setOpen(false)}
                              icon={
                                values?.icon ? values.icon : values.event_icon
                              }
                              program={program}
                            />
                          </div>
                        </Col>
                      </ModalBody>
                    </Modal>

                    <AddSocialWallImageModal
                      isSocialWallOpen={isSocialWallOpen}
                      toggleSocialWall={toggleSocialWall}
                      setSocialWall={form.mutators.setSocialWall}
                      setSocialWallModal={setSocialWallModal}
                      socialWallImage={values?.social_wall_image}
                      program={program}
                    />
                  </>
                )}
              </Form>
            </CardBody>
            <Card>
              <CardBody>
                <Row>
                  <Col md="6" lg="6" xl="6">
                    <Button
                      style={{
                        cursor: "pointer",
                        paddingTop: 3,
                        paddingBottom: 3,
                      }}
                      disabled={loading}
                      className="btn btn-primary"
                      color="#ffffff"
                      onClick={toggleModal}
                    >
                      Add Award Level
                    </Button>
                    <AddAwardLevel
                      visible={visible}
                      onClose={toggleModal}
                      onSave={handleSave}
                      data={dataAwardLevel}
                      programId={programId}
                      organization={program.organization_id}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Table
                      rowKey="id"
                      columns={columnsEventAwardsLevel}
                      dataSource={dataEventAwardsLevels}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Card>
        </Col>
        <SaveHierarchyModal
          isOpenHierarchy={isOpenHierarchy}
          toggleHierarchy={toggleHierarchy}
          onSubmit={onSubmit}
          onSubmitHierarchy={onSubmitHierarchy}
        />

        <SaveSelectedHierarchyModal
          isOpenHierarchyList={isOpenHierarchyList}
          toggleHierarchyList={toggleHierarchyList}
          onSubmitHierarchyList={onSubmitHierarchyList}
          columnsHierarchyList={columnsHierarchyList}
          hierarchyListData={hierarchyListData}
        />

        <SavedResultHierarchyModal
          isOpenHierarchyResult={isOpenHierarchyResult}
          toggleHierarchyResult={toggleHierarchyResult}
          columnsHierarchyResult={columnsHierarchyResult}
          hierarchyListDataResult={hierarchyListDataResult}
        />

        <RemoveHierarchyModal
          isDeleteHierarchy={isDeleteHierarchy}
          toggleDeleteHierarchy={toggleDeleteHierarchy}
          onDeleteHierarchy={onDeleteHierarchy}
          onClickDeleteEvent={onClickDeleteEvent}
          eventId={eventId}
        />
        <RemoveSelectedHierarchyModal
          isDeleteHierarchyList={isDeleteHierarchyList}
          toggleDeleteHierarchyList={toggleDeleteHierarchyList}
          onDeleteHierarchyList={onDeleteHierarchyList}
          columnsDeleteHierarchyList={columnsDeleteHierarchyList}
          deleteHierarchyListData={deleteHierarchyListData}
        />
        <DeletedResultHierarchyModal
          isDeleteHierarchyResult={isDeleteHierarchyResult}
          toggleDeleteHierarchyResult={toggleDeleteHierarchyResult}
          columnsHierarchyResult={columnsHierarchyResult}
          deletehierarchyListDataResult={deletehierarchyListDataResult}
          programId={programId}
          history={history}
        />
      </Container>
    );
  }
};

export default withRouter(connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization
}))(Edit));
